/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_RevokeInputs */

const en_us2_planshare_revoke = /** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off`)
};

const pt_br2_planshare_revoke = /** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar`)
};

const pt_pt2_planshare_revoke = /** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar`)
};

/** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */
const es_419_planshare_revoke = en_us2_planshare_revoke;

/** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */
const fr_fr2_planshare_revoke = en_us2_planshare_revoke;

/** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */
const de_de2_planshare_revoke = en_us2_planshare_revoke;

/** @type {(inputs: Planshare_RevokeInputs) => LocalizedString} */
const it_it2_planshare_revoke = en_us2_planshare_revoke;

/**
* | output |
* | --- |
* | "Turn off" |
*
* @param {Planshare_RevokeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_revoke = /** @type {((inputs?: Planshare_RevokeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_RevokeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_revoke(inputs)
	if (locale === "es-419") return es_419_planshare_revoke(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_revoke(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_revoke(inputs)
	if (locale === "de-DE") return de_de2_planshare_revoke(inputs)
	if (locale === "it-IT") return it_it2_planshare_revoke(inputs)
	return en_us2_planshare_revoke(inputs)
});
export { planshare_revoke as "planshare.revoke" }